import javascript from "../../assets/logo-javascript.svg";
import typescript from "../../assets/Typescript_logo.svg";
import react from "../../assets/React-icon.svg";
import html from "../../assets/HTML5.svg";
import css from "../../assets/CSS3_logo.svg";
import scss from "../../assets/Sass_Logo_Color.svg";
import bootstrap from "../../assets/bootstrap.svg";
import tailwindCSS from "../../assets/Tailwind.svg";
import materialU from "../../assets/Logo_material_design.svg";
import git from "../../assets/Git_icon.svg";
import github from "../../assets/github-mark.svg";
import npm from "../../assets/npm.svg";
import gulp from "../../assets/gulp-logo.svg";
import WordPress from "../../assets/wordpress-icon.svg";
import figma from "../../assets/Figma-logo.svg";

export interface SkillsType {
    id: number,
    name: string,
    icon: string
}

export interface ExperianceType {
    id: number,
    name: string,
    company: string,
    desc: string[],
    date: string,
}

export interface ExperianceTypeTranslation {
    en: ExperianceType[],
    ua: ExperianceType[],
    ru: ExperianceType[]
}

export const experience: ExperianceTypeTranslation = {
  en: [  
    {
      id: 1,
      name: 'Websites creator/Frontend developer',
      company: 'Freelance',
      desc: [
        'Developing custom layouts and responsive web designs using HTML, CSS, JavaScript, and popular JavaScript libraries',
        'Working with CMS platforms (primarily WordPress) to design and deploy dynamic websites, optimizing for SEO and performance',
        'Collaboration with both large corporations and freelance work to develop a variety of technical skills',
        'Successfully delivered 20+ unique website projects within deadlines, ensuring cross-browser compatibility and responsiveness'
      ],
      date: 'April 2020 — present',
    },
    {
      id: 3,
      name: 'Frontend developer',
      company: 'Equinox',
      desc: [
        'Created websites by HTML, CSS(SCSS), JavaScript',
        'Designed and implemented additional functionalities via JavaScript and jQuery, ensuring tailored client solutions',
        'Delivered seamless cross-device experiences with responsive layouts, increasing mobile usability scores by 25%',
        'Maintained a keen focus on UX/UI design, creating intuitive and visually appealing web interfaces'
      ],
      date: 'June 2021 — September 2022',
    },
    {
      id: 2,
      name: 'Landing page Developer',
      company: 'Agaton Limited',
      desc: [
        'Created 50+ marketing landing pages for promotions and advertising using HTML, CSS, JavaScript, and website builders',
        'Designed and implemented interactive features, including advanced animations, custom calculators, and a personal account dashboard, enhancing user engagement and functionality',
        'Streamlined content production workflows for the marketing department, improving page creation efficiency by 30%',
        'Gained foundational knowledge in marketing principles'
      ],
      date: 'May 2020 — January 2021',
    },
    {
      id: 4,
      name: 'Websites creator (low code)',
      company: 'Web Vesta',
      desc: [
        'Built responsive websites (from landing pages to online stores) using low-code tools and HTML/CSS with layouts provided in PSD files',
        'Optimized images and graphics, improving website loading times by 40%',
        'Connected and configured various CMS modules and plugins, specializing in Drupal-based development',
        'Writing additional scripts and plugins in JS and jQuery'
      ],
      date: 'November 2018 — April 2020',
    }
  ],
  ua: [  
    {
      id: 1,
      name: 'Розробник веб-сайтів/Frontend Developer',
      company: 'Freelance',
      desc: [
        'Розробка індивідуальних та адаптивних веб-сайтів з використанням HTML, CSS, JavaScript та популярних бібліотек JavaScript',
        'Робота з платформами CMS (перш за все WordPress) для розробки та розгортання динамічних веб-сайтів, оптимізації для SEO та продуктивності',
        'Співпраця як з великими корпораціями, так і позаштатна робота',
        'Успішно виконано понад 20 унікальних проектів веб-сайтів у встановлені терміни, забезпечуючи кросбраузерну сумісність і оперативність'
      ],
      date: 'Квітень 2020 — по теперішній час',
    },
    {
      id: 3,
      name: 'Frontend developer',
      company: 'Equinox',
      desc: [
        'Створення веб-сайтів за допомогою HTML, CSS(SCSS), JavaScript',
        'Розроблено та реалізовано додаткові функції за допомогою JavaScript і jQuery, що забезпечує індивідуальні клієнтські рішення',
        'Забезпечує зручну взаємодію на різних пристроях завдяки адаптивной верстки, підвищуючи показники зручності використання на мобільних пристроях на 25%',
        'Приділяла особливуувагу до UX/UI дизайні, створюючи інтуїтивно зрозумілі та візуально привабливі веб-інтерфейси'
      ],
      date: 'Червень 2021 — Вересень 2022',
    },
    {
      id: 2,
      name: 'Landing page Developer',
      company: 'Agaton Limited',
      desc: [
        'Створила понад 50 маркетингових лендінгов для просування та реклами за допомогою HTML, CSS, JavaScript та конструкторів веб-сайтів',
        'Розробляла та впровадживала інтерактивні функції, включаючи розширені анімації, спеціальні калькулятори та інформаційну панель особистого облікового запису, що покращиило взаємодію користувачів та покращує функціональність',
        'Удосконаліла робочий процес створення лендінгов для відділу маркетингу, що покращує ефективність створення сторінок на 30%',
        'Отримала фундаментальні знання про принципи маркетингу, узгоджуючи зусилля щодо розвитку зі стратегічними цілями бізнесу'
      ],
      date: 'Травень 2020 — Січень 2021',
    },
    {
      id: 4,
      name: 'Створювач сайтів (low code)',
      company: 'Web Vesta',
      desc: [
        'Створювала адаптивні веб-сайти (від цільових сторінок до онлайн-магазинів) за допомогою інструментів low code та HTML/CSS по макетам, наданими у файлах PSD',
        'Оптимізовивала зображення та графікау, що покращіло час завантаження веб-сайтів на 40%',
        'Підключала та налаштувивала різні модулі та плагіни CMS, на основі Drupal',
        'Разробка додаткових скриптів та плагінів в JS і jQuery'
      ],
      date: 'Листопад 2018 — Квітень 2020',
    }
  ],
  ru: [  
    {
      id: 1,
      name: 'Разработчик веб-сайтов/Frontend Developer',
      company: 'Freelance',
      desc: [
        'Разработка индивидуальных и адаптивных веб-сайтов с использованием HTML, CSS, JavaScript и популярных библиотек JavaScript',
        'Работа с платформами CMS (в первую очередь WordPress) для разработки и развертывания динамических веб-сайтов, оптимизации для SEO и производительности.',
        'Сотрудничество как с крупными корпорациями, так и внештатная работа',
        'Успешно реализовано более 20 уникальных веб-проектов в срок, с обеспечением кроссбраузерной совместимости и адаптивности'
      ],
      date: 'Апрель 2020 — нв',
    },
    {
      id: 3,
      name: 'Frontend developer',
      company: 'Equinox',
      desc: [
        'Создавала веб-сайты с помощью HTML, CSS(SCSS), JavaScript',
        'Разрабатывала и реализовала дополнительные функции с помощью JavaScript и jQuery для индивидуальных решений клиентов',
        'Обеспечивала бесперебойное взаимодействие с различными устройствами благодаря адаптивной вёрстке, что повышало показатели UX мобильных устройств на 25%',
        'Уделяла особое внимание дизайну UX/UI, создавая интуитивно понятные и визуально привлекательные веб-интерфейсы'
      ],
      date: 'Июнь 2021 г. — Сентябрь 2022 г.',
    },
    {
      id: 2,
      name: 'Landing page Developer',
      company: 'Agaton Limited',
      desc: [
        'Создала более 50 маркетинговых лендингов для продвижения и рекламы с использованием HTML, CSS, JavaScript и конструкторов сайтов',
        'Разработала и реализовала интерактивные функции, включая расширенную анимацию, пользовательские калькуляторы и панель управления персональным кабинетом, что повышало вовлеченность пользователей и функциональность',
        'Оптимизировала рабочие процессы по производству лендингов для отдела маркетинга, повышающие эффективность создания страниц на 30%',
        'Получила базовые знания в области маркетинга'
      ],
      date: 'Май 2020 — Январь 2021',
    },
    {
      id: 4,
      name: 'Создатель веб-сайтов (low code)',
      company: 'Web Vesta',
      desc: [
        'Создавала адаптивные веб-сайты (от лендингов до интернет-магазинов) с использованием инструментов low code и HTML/CSS по макетам, предоставленными в файлах PSD',
        'Оптимизировала изображения и графику, что сокращало время загрузки веб-сайтов на 40%',
        'Подключала и настроивала различные модули и плагины CMS, созданные на базе Drupal',
        'Разробатывала дополнительные скрипты и плагины на JS и jQuery'
      ],
      date: 'Ноябрь 2018 — Апрель 2020',
    }
  ]
}

  export const skills: SkillsType[] = [
    {
      id: 1,
      name: 'JavaScript',
      icon: javascript
    },
    {
      id: 2,
      name: 'TypeScript',
      icon: typescript
    },
    {
      id: 3,
      name: 'React',
      icon: react
    },
    {
      id: 4,
      name: 'HTML',
      icon: html
    },
    {
      id: 5,
      name: 'CSS',
      icon: css
    },
    {
      id: 6,
      name: 'SCSS',
      icon: scss
    },
    {
      id: 7,
      name: 'Bootstrap',
      icon: bootstrap
    },
    {
      id: 8,
      name: 'TailwindCSS',
      icon: tailwindCSS
    },
    {
      id: 9,
      name: 'MaterialUI',
      icon: materialU
    },
    {
      id: 10,
      name: 'Git',
      icon: git
    },
    {
      id: 11,
      name: 'GitHub',
      icon: github
    },
    {
      id: 12,
      name: 'npm',
      icon: npm
    },
    {
      id: 13,
      name: 'Gulp',
      icon: gulp
    },
    {
      id: 14,
      name: 'WordPress',
      icon: WordPress
    },
    {
      id: 15,
      name: 'Figma',
      icon: figma
    }
  ]